<div class="report-wrapper w-full md:m-[0] mt-[2rem]">
  <div class="flex w-full justify-center">
    <div class="w-[90%] md:w-[60%] flex items-center">
      <app-dropdown
        (checkForErrors)="checkForErrors($event)" [enableClearSelection]="true"
        [error]="errorMessages['reports']" [loading]="reportDropDownOptionsLoading"
        [options]="reportDropDownOptions"
        [parentFormGroup]="form"
        class="w-full"
        controlName="reports"
        label="Select Report"
        placeholder="Select Report"
        type="small"
      />
    </div>
  </div>
  <div class="separator-section w-full">
    <hr class="w-full separator">
  </div>

  <div
    *ngIf="form.get('clientId') || form.get('groupId') || form.get('participantId')"
    class="select-clinic-group-section w-full flex justify-center"
  >
    <div class="w-[90%] flex flex-col items-center md:flex-row md:justify-between">
      <app-filter-dropdown
        (checkForErrors)="checkForErrors($event)" (onNextPage)="fetchClinicsNextPageOptions()"
        *ngIf="form.get('clientId')"
        [enableAllSelection]="reportFormMap[form.get('reports').value]?.clientId?.enableAllSelection"
        [enableClearSelection]="true"
        [enableMultiple]="reportFormMap[form.get('reports').value]?.clientId?.multiSelect"
        [enableSearch]="true" [error]="errorMessages['clientId']" [hasNext]="clientHasNext"
        [label]="reportFormMap[form.get('reports').value]?.clientId.label"
        [loading]="clinicsDropDownOptionsLoading"
        [ngClass]="(form.get('clientId') && !form.get('groupId') &&
                     !form.get('participantId')) ? 'w-full':
                     (form.get('clientId') && form.get('groupId') &&
                     !form.get('participantId'))?'w-full md:w-[48%]' :
                     'w-full md:w-[31%]'"
                     [options]="clinicsDropDownOptions"
                     [parentFormGroup]="form"
        [placeholder]="reportFormMap[form.get('reports').value]?.clientId.placeHolder"
        [searchPlaceholder]="'Search'"
        controlName="clientId"
        filterControlName="clientSearch" type="small">
      </app-filter-dropdown>
      <app-filter-dropdown
        (checkForErrors)="checkForErrors($event)"
        (onNextPage)="fetchGroupsNextPageOptions()"
        *ngIf="form.get('groupId')"
        [enableClearSelection]="true"
        [enableMultiple]="reportFormMap[form.get('reports').value].groupId?.multiSelect"
        [enableSearch]="true"
        [error]="errorMessages['groupId']"
        [hasNext]="groupHasNext"
        [label]="reportFormMap[form.get('reports').value].groupId?.label"
        [loading]="groupsDropDownOptionsLoading"
        [ngClass]="(form.get('groupId') && !form.get('clientId') &&
                     !form.get('participantId'))?'w-full':
                     (form.get('clientId') && form.get('groupId') &&
                     !form.get('participantId'))?'w-full md:w-[48%]' :
                    form.get('groupId') &&  form.get('participantId') &&
                    loggedInUserRole === roleMap.superAdmin ?
                    'w-full md:w-[31%]':'w-full md:w-[48%]'" [options]="groupsDropDownOptions"
        [parentFormGroup]="form"
        [placeholder]="reportFormMap[form.get('reports').value].groupId?.placeHolder"
        [searchPlaceholder]="'Search'"
        controlName="groupId"
        filterControlName="groupSearch" type="small">
      </app-filter-dropdown>
      <app-filter-dropdown
        (checkForErrors)="checkForErrors($event)" (onNextPage)="fetchParticipantNextPageOptions()"
        *ngIf="form.get('participantId')"
        [enableClearSelection]="true"
        [enableMultiple]="reportFormMap[form.get('reports').value].participantId?.multiSelect"
        [enableSearch]="true"
        [error]="errorMessages['participantId']"
        [hasNext]="participantHasNext" [label]="reportFormMap[form.get('reports').value].participantId?.label"
        [loading]="participantsDropDownOptionsLoading"
        [ngClass]="(loggedInUserRole === roleMap.superAdmin) ?
        'w-full md:w-[31%]':'w-full md:w-[48%]'" [options]="participantsDropDownOptions"
        [parentFormGroup]="form"
        [placeholder]="reportFormMap[form.get('reports').value].participantId?.placeHolder"
        [searchPlaceholder]="'Search'"
        controlName="participantId"
        filterControlName="participantSearch"
        type="small">
      </app-filter-dropdown>
    </div>
  </div>
  <div
    *ngIf="form.get('fromDate') || form.get('toDate') || form.get('behaviorType')"
    class="select-date-section w-full flex justify-center"
  >
    <div class="w-[90%] flex flex-col items-center md:flex-row md:justify-start">
      <div class="w-full flex flex-col md:w-[31%] md:flex-row md:justify-between">
        <app-date-picker
          (checkForErrors)="checkForErrors($event)"
          *ngIf="form.get('fromDate')"
          [error]="errorMessages['fromDate']"
          [parentFormGroup]="form"
          class="w-full md:w-[48%]"
          controlName="fromDate"
          label="From" placeholder="From" type="small"></app-date-picker>
        <app-date-picker
          (checkForErrors)="checkForErrors($event)"
          *ngIf="form.get('toDate')"
          [error]="errorMessages['toDate']"
          [min]="form.get('fromDate').value"
          [parentFormGroup]="form"
          class="w-full md:w-[48%]"
          controlName="toDate"
          label="To"
          placeholder="To"
          type="small"
        ></app-date-picker>
      </div>
      <app-dropdown
        (checkForErrors)="checkForErrors($event)"
        *ngIf="form.get('behaviorType')"
        [enableClearSelection]="true"
        [enableMultiple]="true"
        [error]="errorMessages['behaviorType']"
        [loading]="behaviorTypeDropDownOptionsLoading"
        [options]="behaviorTypeDropDownOptions"
        [parentFormGroup]="form"
        class="w-full md:w-[31%] md:ml-[3.5%]"
        controlName="behaviorType"
        label="Behavior Type"
        placeholder="Behavior Type"
        type="small">
      </app-dropdown>
    </div>
  </div>
  <div
    *ngIf="form.get('surveyId') "
    class="select-date-section w-full flex justify-center"
  >
    <div class="w-[90%] flex flex-col items-center md:flex-row md:justify-start">
      <div class="w-[90%] flex flex-col items-center md:flex-row md:justify-between">
        <app-dropdown
          (checkForErrors)="checkForErrors($event)"
          *ngIf="form.get('surveyId')"
          [enableMultiple]="false"
          [error]="errorMessages['surveyId']"
          [loading]="questionnaireDropDownOptionsLoading"
          [options]="questionnaireDropDownOptions"
          [parentFormGroup]="form"
          class="w-full md:w-[31%] md:ml-[3.5%]"
          controlName="surveyId"
          label="Questionnaire"
          placeholder="Questionnaire"
          type="small"
        />
      </div>
    </div>
  </div>

  <div class="w-full flex justify-center">
    <div class="download-button-wrapper flex justify-end w-[90%]">
      <app-primary-button
        (handleClick)="downloadButtonClicked()"
        [isDisabled]="form.invalid" class="w-full md:w-[30%]"
        type="small">
        Download
      </app-primary-button>
    </div>
  </div>

  <div class="w-full flex justify-center report-section">
    <mat-expansion-panel
      [expanded]="expandPanel"
      class="mat-elevation-z0 expansion-panel w-[95%]">
      <mat-expansion-panel-header
        class="bg-black-100 expansion-panel-header justify-center">
        <div class="title">
          My Reports
        </div>
      </mat-expansion-panel-header>
      <div
        (scrolled)="getNext()"
        [infiniteScrollDistance]="2"
        [infiniteScrollThrottle]="10"
        [scrollWindow]="false"
        class="table-wrapper overflow-auto xs:h-[calc(100vh-35rem)] sm:h-[calc(100vh-30rem)] md:h-[calc(100vh-28rem)]"
        infiniteScroll>
        <table
          (matSortChange)="sortData($event)"
          [class.hidden]="reportLoading && isFirstPage"
          [dataSource]="dataSource"
          class="mb-[2rem]"
          mat-table matSort>
          <ng-container
            [sticky]="true"
            matColumnDef="createdAt">
            <th *matHeaderCellDef
                class="min-w-[10rem]"
                mat-header-cell mat-sort-header>
              <div class="th-cell">
                Requested Date
              </div>
            </th>
            <td *matCellDef="let eachRow;let index=index" mat-cell>
              <div class="td-cell">
                <div class="reports-content">
                  {{eachRow.createdAt | date}}
                </div>
              </div>
            </td>
          </ng-container>
          <ng-container matColumnDef="type">
            <th *matHeaderCellDef class="min-w-[10rem]" mat-header-cell mat-sort-header>
              <div class="th-cell reports-title">
                Report
              </div>
            </th>
            <td *matCellDef="let eachRow" mat-cell>
              <div class="td-cell reports-content reports-title">
                {{eachRow?.type?.value }}
              </div>
            </td>
          </ng-container>
          <ng-container matColumnDef="variable">
            <th *matHeaderCellDef class="min-w-[20rem]" mat-header-cell>
              <div class="th-cell reports-title">
                Filters
              </div>
            </th>
            <td *matCellDef="let eachRow ;let index=index" mat-cell>
              <div class="reports-content reports-title reports-variable flex-col items-start">
                <div *ngIf="eachRow?.filters?.clientId">
                  <span
                    *ngIf="eachRow?.filters?.clientId?.length>0"
                    [ngxTippy]="getToolTipsDetails(eachRow?.filters?.clientId)"
                    [tippyName]="'clientTooltip'+ index"
                  >Organization :
                    {{eachRow?.filters?.clientId?.length }} Selected</span>
                  <span
                    *ngIf="eachRow?.filters?.clientId?.length === 0">Organization :
                    All Selected</span>
                </div>
                <div
                  *ngIf="eachRow?.filters?.groupId">
                  <span
                    *ngIf="eachRow?.filters?.groupId.length>0"
                    [ngxTippy]="getToolTipsDetails(eachRow?.filters?.groupId)"
                    [tippyName]="'groupToolTip'+ index"> Groups :
                    {{eachRow?.filters?.groupId.length}} Selected
                  </span>
                  <span *ngIf="eachRow?.filters?.groupId.length === 0"> Groups :
                    All Selected
                  </span>
                </div>
                <div *ngIf="eachRow?.filters?.participantId">
                  <span
                    *ngIf="eachRow?.filters?.participantId?.length > 0"
                    [ngxTippy]="getToolTipsDetails(eachRow?.filters?.participantId)"
                    [tippyName]="'participantIdTooltip'+ index">
                    Participant :
                    {{eachRow?.filters?.participantId?.length}}
                    Selected</span>
                  <span
                    *ngIf="eachRow?.filters?.participantId?.length === 0"
                    [tippyName]="'participantIdTooltip'+ index"> Participant :
                    All
                    Selected</span>

                </div>
                <div *ngIf="eachRow?.variable?.behaviorType?.length > 0">
                  <span
                    [ngxTippy]="getToolTipList('behaviorType',eachRow?.variable?.behaviorType)"
                    [tippyName]="'behaviorTypeTooltip'+ index"> Behavior Type :
                    {{eachRow?.variable?.behaviorType?.length}}
                    Selected </span>

                </div>
                <div
                  *ngIf="eachRow?.filters?.fromDate">
                  From Date: {{eachRow?.filters?.fromDate | date}}
                </div>
                <div
                  *ngIf="eachRow?.filters?.toDate">
                  To Date : {{eachRow?.filters?.toDate | date}}
                </div>
              </div>
            </td>
          </ng-container>
          <ng-container matColumnDef="status">
            <th *matHeaderCellDef class="min-w-[10rem]" mat-header-cell mat-sort-header>
              <div class="th-cell reports-title">
                Status
              </div>
            </th>
            <td *matCellDef="let eachRow" mat-cell>
              <div class="td-cell reports-content reports-title flex items-center gap-2">
                <!-- Show spinner ONLY if report is generating AND not yet available -->
                <mat-spinner 
                  *ngIf="isReportGenerating(eachRow.status.key) && !isReportReadyForDownload(eachRow.status.key)" 
                  [diameter]="20"
                  class="inline-block">
                </mat-spinner>
                
                <!-- Show status text with color based on status -->
                <span [ngClass]="{
                  'text-orange-500': isReportGenerating(eachRow.status.key),
                  'text-green-500': isReportReadyForDownload(eachRow.status.key),
                  'text-red-500': isReportFailed(eachRow.status.key)
                }">
                  {{ getStatusDisplayText(eachRow.status.key, eachRow?.status?.value) }}
                </span>
                
                <!-- Show error message if failed -->
                <span *ngIf="isReportFailed(eachRow.status.key) && eachRow.error" 
                      class="text-xs text-red-400"
                      [title]="eachRow.error">
                  (Error)
                </span>
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="actions">
            <th *matHeaderCellDef class="min-w-[10rem]" mat-header-cell>
              <div class="th-cell reports-title">
                Actions
              </div>
            </th>
            <td *matCellDef="let eachRow" mat-cell>
              <div class="td-cell reports-content reports-title flex items-center gap-3">
                
                <!-- Download button - only show when report is ready (status 2) -->
                <button
                  *ngIf="isReportReadyForDownload(eachRow.status.key)"
                  (click)="downloadReports(eachRow)"
                  class="download-link-button font-medium flex items-center gap-1"
                  title="Download Report">
                  <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                  </svg>
                  Download
                </button>

                <!-- Re-generate button - show when NOT generating (includes downloaded, failed, available) -->
                <span
                  (click)="reGeneratedReports(eachRow)" 
                  *ngIf="!isReportGenerating(eachRow.status.key)"
                  class="clickable">
                  Re-Generate Report
                </span>
                
                <!-- Loading indicator - ONLY show when actually generating (status 1 or 5, NOT 2) -->
                <span 
                  *ngIf="isReportGenerating(eachRow.status.key) && !isReportReadyForDownload(eachRow.status.key)"
                  class="text-gray-400">
                  Processing...
                </span>
              </div>
            </td>
          </ng-container>

          <tr *matHeaderRowDef="reportsDisplayColumn" mat-header-row></tr>
          <tr *matRowDef="let row; columns: reportsDisplayColumn;" mat-row></tr>
        </table>
        <div
          *ngIf="reportLoading" [ngClass]="{ 'initial': !dataSource?.length }"
          class="table-loader w-full flex justify-center items-center bg-red">
          <mat-spinner/>
        </div>
        <div
          *ngIf="!dataSource?.length && !reportLoading"
          class="no-data flex flex-col justify-center items-center">
          <div class="text">
            No Data Found
          </div>
        </div>
      </div>
    </mat-expansion-panel>
  </div>
</div>
